<template>
  <div class="policy_warp">
    <div class="policy_content">
      
      <div class="txt">
        <p># hecoos 全域制作平台 - 详细产品知识库</p>
        <p><br></p>
        <p>## 1. 核心理念</p>
         <p>**“设计即实现” (Design to Reality):** hecoos 打通了“方案设计-预演仿真-现场执行”的数据链路，让所有的创意在软件中即可验证，减少现场调试时间和风险。</p>
        <p><br></p>
        <p>## 2. 软件模块详解</p>
        <p>### A. hecoos Studio (预演与总控)</p>
        <p>* **三维场景仿真:** 导入舞台模型，模拟材质、反射及环境光。</p>
        <p>* **投影机光路设计:** 模拟投影机流明、镜头投射比、光路遮挡分析、热区图（Lux Map）。</p>
        <p>* **导播系统 (Director System):** * 支持虚拟摄像机机位预设。</p>
        <p style="text-indent: 2em;">    * 生成电子台本（Cue Sheet），导出带有时间码和画面的脚本文件。</p>
        <p>* **N+N 显示管理:** 任意拼接LED屏幕，支持异形显示设备的UV展开。</p>
        <p><br></p>
        <p>### B. hecoos Lighting (灯光编程)</p>
        <p>* **离线编程:** 无需连接真实灯具即可在软件中编写灯光Show。</p>
        <p>* **双向控制:** 支持 Art-Net 协议，既可以接收控台信号在软件内模拟，也可以由软件直接发送DMX信号控制现场真实灯具。</p>
        <p>* **虚实联动:** 虚拟场景中的灯光效果可自动映射到现场灯具，实现光影同步。</p>
        <p><br></p>
        <p>### C. hecoos xR/VP (虚拟制片解决方案)</p>
        <p>* **AIGC 集成:** 利用AI技术快速生成2.5D背景素材，降低资产制作成本。</p>
        <p>* **摄像机追踪:** 兼容主流追踪系统（如Mosys, Ncam等），支持Free-D协议。</p>
        <p>* **实时渲染:** 基于虚幻引擎（Unreal Engine）或自研引擎，支持光影实时解算。</p>
        <p>* **色彩校正:** 自动校准LED屏幕色彩与摄像机传感器的色差。</p>
        <p>* **AR植入:** 支持前景AR物体与后景虚拟画面的合成。</p>
        <p><br></p>
        <p>## 3. 硬件服务器系列 (Server Series)</p>
        <p>* **Server-C (合成服务器):** xR/VP系统的核心，负责处理摄像机追踪数据、抠像合成及最终画面输出。</p>
        <p>* **Server-R (渲染服务器):** 专为实时渲染设计，搭载顶级显卡，支持集群渲染以处理复杂的3D场景。</p>
        <p>* **Server-D (多媒体服务器):** 侧重于展厅和舞台的视频播放与3D Mapping输出。</p>
        <p><br></p>
        <p>## 4. 关键功能特性</p>
        <p>* **所见即所得:** 软件预演的画面与现场最终呈现效果保持高度一致。</p>
        <p>* **可视化协同:** 导演、灯光师、视觉设计师在同一个数字孪生场景中工作。</p>
        <p>* **全流程支持:** 从投标阶段的效果图视频制作，到执行阶段的控台操作，使用同一套工程文件。</p>
        <p><br></p>
        <p>## 5. 适用场景</p>
        <p>* **影视拍摄:** 电影/电视剧的虚拟背景拍摄（替代绿幕）。</p>
        <p>* **广电直播:** 虚拟演播室、跨年晚会xR舞台。</p>
        <p>* **发布会:** 沉浸式线上虚拟发布会（如小米、比亚迪发布会）。</p>
        <p>* **大型展演:** 奥运会开幕式预演、演唱会舞台设计。</p>
      </div>
    </div>

  </div>
</template>
<script>


export default {
  name: "LLMInfo",
  components: {  },
  data() {
    return {};
  },
  methods: {},
  mounted() { },
};
</script>
<style lang="scss" scoped>
.policy_warp {
  background-color: #fff;

  .policy_content {
    width: 1210px;
    margin: 0 auto;
    padding: 80px 0;


    p {
      font-size: 14px;
      line-height: 28px;
      color: #000;
    }

    ;
  }
}
</style>